//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { theme } from '@bvengineering/unison-core';

import { SummaryReferralsSource } from '@instagram-account/components/summary/referrals/instagramSummaryReferralsModel';

export const SummaryReferralsValue = {
  Revenue: 'revenue',
  Traffic: 'traffic',
} as const;

export type SummaryReferralsValue =
  (typeof SummaryReferralsValue)[keyof typeof SummaryReferralsValue];

export const SUMMARY_REFERRALS_VALUE_LABELS = {
  [SummaryReferralsValue.Revenue]: 'Revenue',
  [SummaryReferralsValue.Traffic]: 'Traffic',
} as const;

export const SUMMARY_REFERRALS_VALUE_TOOLTIPS = {
  [SummaryReferralsValue.Traffic]:
    'Total on-site sessions attributed to this Instagram referral source.',
  [SummaryReferralsValue.Revenue]:
    'Transaction revenue attributed to clickthroughs to site from this Instagram referral source using the attribution window defined by your analytics provider.',
} as const;

export const SUMMARY_REFERRALS_VALUES = [
  SummaryReferralsValue.Traffic,
  SummaryReferralsValue.Revenue,
] as const;

export const SUMMARY_REFERRALS_BASE_SOURCES = [
  SummaryReferralsSource.Like2Buy,
  SummaryReferralsSource.Stories,
  SummaryReferralsSource.PromotedPosts,
] as const;

export const SUMMARY_REFERRALS_LABELS = {
  [SummaryReferralsSource.Like2Buy]: 'Like2Buy',
  [SummaryReferralsSource.Stories]: 'Story Links',
  [SummaryReferralsSource.PromotedPosts]: 'Promoted Posts',
  [SummaryReferralsSource.ShopTags]: 'Shop Tags',
} as const;

export const SUMMARY_REFERRALS_COLORS = {
  [SummaryReferralsSource.Like2Buy]: theme.colors.cyan5,
  [SummaryReferralsSource.Stories]: theme.colors.cyan1,
  [SummaryReferralsSource.PromotedPosts]: theme.colors.cyan3,
  [SummaryReferralsSource.ShopTags]: theme.colors.blue1,
} as const;

export const INSTAGRAM_SUMMARY_REFERRALS_CHART_HEIGHT = 147;
export const INSTAGRAM_SUMMARY_REFERRALS_CHART_WIDTH = 210;

export const DONUT_CHART_CUSTOM_OPTIONS = {
  chart: {
    backgroundColor: theme.colors.white,
    borderColor: theme.colors.white,
    margin: [5, 5, 5, 5],
  },
};
